import { splitHandicap } from '../splitHandicap';
import { xs_languageCode } from '../..';

function duplicateMatchDataWithoutBets(matchData){
	const duplicated = {...matchData};
	delete duplicated.bets;
	return duplicated;
}

function duplicateOddWithoutMatchData(odd){
	const duplicated = {...odd};
	duplicated.matchData = duplicateMatchDataWithoutBets(odd.matchData);
	return duplicated;
}

function duplicateBetWithoutOdds(bet){
	const duplicated = {...bet};
	duplicated.odds = [];
	return duplicated;
}

export function aggregateBetsForPlayer(bets, infoAgg) {
	const auxMap = {};
	for (let kb in bets) {
		const bet = bets[kb];
		const handicapSplitted = splitHandicap(bet.handicap, infoAgg, null, xs_languageCode);
		// se ci sono due anagrafiche, invece di indicizzare per il singolo giocatore, indicizzo per la coppia di giocatori
		const playerId = handicapSplitted.idAnagrafica + (handicapSplitted.idAnagrafica2 != null ? `_${handicapSplitted.idAnagrafica2}` : '');
		if (!auxMap[playerId]) {
			auxMap[playerId] = duplicateBetWithoutOdds(bet);
			auxMap[playerId].odds = [];
		}
		let dia = bet.dia? bet.dia : "";
		if (dia.indexOf('$') >= 0) {
			const idAnag1 = dia.split('$')[0];
			const idAnag2 = dia.split('$')[1];
			// l'info aggiuntiva può essere presentata almeno in 3 modi diversi all'interno della descrizione impostata da CMS. Capisco qual è, in modo da isolare il resto della descrizione della scommessa (che va nella parte destra del box handicap)
			const chanches = {
				' + ' : `${idAnag1} + ${idAnag2}`,
				' / ' : `${idAnag1} / ${idAnag2}`,
				' ' : `${idAnag1} ${idAnag2}`,
				' oppure ' : `${idAnag1} oppure ${idAnag2}`,
				' o ' : `${idAnag1} oppure ${idAnag2}`,
			};
			
			let found = false;
			for (let k in chanches) {
				const contained = chanches[k];
				if (bet.desc.indexOf(contained) >= 0 ) {
					dia = contained;
					found = true;
				}
			}

			if (!found) {
				dia = dia.replace('$', ' '); // caso default
			}
		}
		const descDrawRadix = bet.desc.indexOf(dia) >= 0 ? bet.desc.replace(dia, '').trim() : bet.desc;
		auxMap[playerId].desc = dia;
		for (let ko in bet.odds) {
			const odd = duplicateOddWithoutMatchData(bet.odds[ko]);
			let descForBetsAggregate = descDrawRadix;

            if (bet.odds.length > 1) {
				descForBetsAggregate = `${descForBetsAggregate} - ${odd.desc}`;
				// escludo i casi in cui siamo con due giocatori. Nel caso di (esempio) tipo handicap 37, la parte sinistra dell'handicap sarà composta da 2 giocatori
				//if (handicapSplitted.idAnagrafica2 == null) {
	            //    descForBetsAggregate = parseHandicap(descForBetsAggregate, bet.handicap, bet.tipoHandicap, bet.eqs, dia, false);				
				//}
			}
            
            odd.descForBetsAggregate = descForBetsAggregate;
			auxMap[playerId].odds.push(odd);
			auxMap[playerId].dia = dia;
		}
	}
	const finalArray = [];
	for (let k in auxMap) {
		finalArray.push(auxMap[k]);
	}
	return finalArray;
}
